import { cast, getParent, types } from 'mobx-state-tree';
const SelectedDetails = types.model({
  id: types.string,
  accountId: types.string,
  number: types.string,
  name: types.maybeNull(types.string),
  propertyId: types.maybeNull(types.string),
  isEmail: types.boolean,
  occupancy: types.string,
  inlineDate: types.maybeNull(types.string),
  _newoccupancy: types.string,
  _moveOutDate: types.maybeNull(types.string),
  _inlineDate: types.maybeNull(types.string)
});
const ResidenciesMultiActionStore = types.model('ResidenciesMultiActionStore', {
  selectedDetails: types.optional(types.array(SelectedDetails), [])
}).actions(store => ({
  getResidentById(id) {
    try {
      return store.selectedDetails.find(i => i.id === id);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setNewOccupancyById(id, value) {
    try {
      const index = store.selectedDetails.findIndex(i => i.id === id);
      store.selectedDetails[index]._newoccupancy = value;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setNewInlineDateById(id, value) {
    try {
      const index = store.selectedDetails.findIndex(i => i.id === id);
      store.selectedDetails[index]._inlineDate = value;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setNewInlineDateByIdToAll(id) {
    try {
      const index = store.selectedDetails.findIndex(i => i.id === id);
      const value = store.selectedDetails[index]._inlineDate;
      store.selectedDetails.map(i => {
        i._inlineDate = value;
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setSelectedDetails(data) {
    try {
      var _data$residencyId, _ref, _data$Unitname, _ref2, _data$Fullname, _ref3, _data$email;
      store.selectedDetails.push({
        id: (_data$residencyId = data.residencyId) !== null && _data$residencyId !== void 0 ? _data$residencyId : data.id,
        accountId: data.accountId,
        number: (_ref = (_data$Unitname = data.Unitname) !== null && _data$Unitname !== void 0 ? _data$Unitname : data.unitName) !== null && _ref !== void 0 ? _ref : data.number,
        name: (_ref2 = (_data$Fullname = data.Fullname) !== null && _data$Fullname !== void 0 ? _data$Fullname : data.fullname) !== null && _ref2 !== void 0 ? _ref2 : data.name,
        isEmail: (_ref3 = (_data$email = !!data.email) !== null && _data$email !== void 0 ? _data$email : !!data.newEmail) !== null && _ref3 !== void 0 ? _ref3 : data.isEmail,
        occupancy: "".concat(data.occupancy),
        _newoccupancy: '1',
        _moveOutDate: null,
        propertyId: data.propertyId,
        inlineDate: getParent(store).company.companyFeatureStore.isAppfolio ? data.billingStartDateOnly : data.enrolledDateOnly,
        _inlineDate: null
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  desetSelectedDetails(id) {
    try {
      const index = store.selectedDetails.findIndex(i => i.id === id);
      store.selectedDetails.splice(index, 1);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  selectAll(data) {
    try {
      store.selectedDetails = cast([]);
      data.map(i => {
        if (i.vacant) return;
        store.setSelectedDetails(i);
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  deselectAll() {
    try {
      store.selectedDetails = cast([]);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
})).views(store => ({
  get isSelectedIsMultiPropertyView() {
    return store.selectedDetails.find(i => i.propertyId !== null);
  },
  get isSelectedFromSingleProperty() {
    return Array.from(new Set(store.selectedDetails.map(i => i.propertyId))).length === 1;
  },
  get selectedPropertyIds() {
    return Array.from(new Set(store.selectedDetails.map(i => i.propertyId)));
  }
}));
export const residenciesMultiActionStore = types.optional(ResidenciesMultiActionStore, {});